import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { THEME_UI_DEFAULT_KEY } from '../../theme-provider/types.esm.js';
import { useSafeThemeUI } from '../../theme-provider/use-theme-ui.esm.js';
import { getSafeReadableColor } from '../../utils/colors.esm.js';
import { get, EMPTY_OBJECT } from '../../utils/object.esm.js';
import { omitPaddingX, omitPaddingY } from '../../utils/props-utils.esm.js';
import { reactNodeToString } from '../../utils/react-helpers.esm.js';
import { resolveSize, getStepSize } from '../../utils/size-utils.esm.js';
import { FlexInlinePrivate } from '../_primitives/flex/flex-inline.esm.js';
import { TextPrivate } from '../_primitives/text/text.esm.js';
import Button from '../button/button.esm.js';
import { borderWidths } from '../../themes/theme-keys/border-widths.esm.js';

var _excluded = ["variant", "className", "onRemove", "size", "px", "gap", "useThemeVariant", "outline", "color", "children", "border", "prefixItem", "postfixItem", "disabled", "textProps", "sx"];
var closeIconProps = {
  icon: 'close',
  strokeWidth: 2.5
};
var Tag = /*#__PURE__*/React.forwardRef(function Tag(props, ref) {
  var theme = useSafeThemeUI(props);
  var variant = props.variant,
    className = props.className,
    onRemove = props.onRemove,
    _props$size = props.size,
    size = _props$size === void 0 ? 'xs' : _props$size,
    _props$px = props.px,
    px = _props$px === void 0 ? 'xs' : _props$px,
    _props$gap = props.gap,
    gap = _props$gap === void 0 ? 'xs' : _props$gap,
    _props$useThemeVarian = props.useThemeVariant,
    useThemeVariant = _props$useThemeVarian === void 0 ? !!variant : _props$useThemeVarian,
    outline = props.outline,
    color = props.color,
    children = props.children,
    border = props.border,
    prefixItem = props.prefixItem,
    postfixItem = props.postfixItem,
    disabled = props.disabled,
    _props$textProps = props.textProps,
    textProps = _props$textProps === void 0 ? EMPTY_OBJECT : _props$textProps,
    _props$sx = props.sx,
    sx = _props$sx === void 0 ? EMPTY_OBJECT : _props$sx,
    rest = _objectWithoutProperties(props, _excluded);

  //const _fontSize = resolveSize(size, get(theme, 'sizes.fontSizes'))
  var _IconSize = resolveSize(getStepSize(size, -4), get(theme, 'sizes.icon'));
  var defaultTextColor = get(theme, 'colors.text', 'black');
  var defaultWhite = get(theme, 'colors.white', 'white');
  var _color = color ? get(theme, "colors.".concat(color, ".").concat(THEME_UI_DEFAULT_KEY), get(theme, "colors.".concat(color), 'black')) : defaultTextColor;
  var wrapperCss = useMemo(function () {
    return _objectSpread2({}, useThemeVariant ? _objectSpread2({}, onRemove ? {
      pl: px
    } : {
      px: px
    }) : outline ? {
      border: border ? border : "".concat(borderWidths["default"], " solid ").concat(_color),
      bg: get(theme, "colors.".concat(color, ".light"), defaultWhite),
      color: get(theme, "colors.".concat(color, ".dark"), _color),
      px: px
    } : {
      bg: _color,
      border: border ? border : 'transparent',
      color: "".concat(getSafeReadableColor(_color, defaultTextColor, defaultWhite)),
      px: px
    });
  }, [_color, border, color, defaultTextColor, defaultWhite, onRemove, outline, px, theme, useThemeVariant]);
  var wrapperSx = useMemo(function () {
    return _objectSpread2({
      '&.is-disabled': {
        opacity: 0.75
      }
    }, omitPaddingX(omitPaddingY(sx)));
  }, [sx]);
  return /*#__PURE__*/React.createElement(FlexInlinePrivate, _extends({
    ref: ref,
    variant: useThemeVariant ? variant !== null && variant !== void 0 ? variant : THEME_UI_DEFAULT_KEY : undefined,
    __themeKey: "tags",
    className: classNames('csg-tui-tag', className, {
      'is-disabled': !!disabled
    }),
    alignItems: "center"
    //alignItems={prefixItem || postfixItem ? 'center' : 'baseline'}
    ,
    pl: prefixItem ? 'xs-2' : undefined,
    justifyContent: "center",
    minWidth: "0px",
    lineHeight: "1.4" // Cosmos does not  have 1.4, but required
    //fontSize={_fontSize}
    ,
    gap: onRemove ? gap : undefined
  }, omitPaddingX(omitPaddingY(rest)), {
    __css: wrapperCss,
    sx: wrapperSx
  }), /*#__PURE__*/React.createElement(FlexInlinePrivate, {
    justifyContent: "center",
    alignItems: "center",
    minWidth: "0px",
    gap: "xxs"
  }, prefixItem && /*#__PURE__*/React.createElement(FlexInlinePrivate, null, prefixItem), /*#__PURE__*/React.createElement(TextPrivate, _extends({
    as: "div",
    alignItems: "center",
    ellipsis: true
  }, textProps, {
    postContent: reactNodeToString(postfixItem)
  }), children), postfixItem && /*#__PURE__*/React.createElement(FlexInlinePrivate, null, postfixItem)), onRemove && /*#__PURE__*/React.createElement(Button, {
    variant: "icon",
    icon: closeIconProps,
    color: "inherit",
    disabled: disabled,
    tabIndex: -1,
    p: "0",
    size: _IconSize,
    onClick: onRemove
  }));
});

export default Tag;
//# sourceMappingURL=tag.esm.js.map
